import { LUBAV_SUPERSESSIONS, LubavSessionType } from '@backrs_ui/grow-ui/src/models/models';

import { setActiveSessionType } from '../redux/lubavSessionState/lubavSessionState';
import type { AppDispatch } from '../redux/store';

const determineActiveSession = (path: string): LubavSessionType | null => {
  // check if we're in a solution session
  if (path.startsWith('/solution-session/')) {
    const sessionId = path.split('/')[2];

    return sessionId as LubavSessionType;
  }
  // check if we're in an office hours session
  else if (path.startsWith('/office-hours/')) {
    const sessionType = path.split('/')[2];

    return sessionType as LubavSessionType;
  }
  // check if we're in a superuser/supercoach session
  else if (path === '/superuser') {
    return LUBAV_SUPERSESSIONS.SUPERUSER;
  } else if (path === '/supercoach') {
    return LUBAV_SUPERSESSIONS.SUPERCOACH;
  }

  return null;
};

export const setLubavSession = (pathname: string, dispatch: AppDispatch) => {
  const activeSession = determineActiveSession(pathname);

  dispatch(setActiveSessionType(activeSession));

  return activeSession;
};
